export default "__VITE_ASSET__CzostfMN__"